import React from 'react';
import {Toaster} from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from '../components';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import '../styles/whitaijiLibrary.css';
import '../styles/globals.css';
import '../styles/offer.css';
import '../styles/devicePin.css';
import '../styles/registerTable.css';
import 'keen-slider/keen-slider.min.css';
import {StateContext} from '../context/StateContext';
import { OfflineContext } from '../context/OfflineContext';
import { windowStorage } from '../lib/utils';
import { Analytics } from '@vercel/analytics/react';
import { AuthContextProvider } from '../context/AuthContext';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '../components/ErrorFallback';
import { ManagementContext } from '../context/ManagementContext';
//import { SpeedInsights } from "@vercel/speed-insights/next"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // Disable retries to ensure errors propagate to error boundary
    },
  },
});

function MyApp({Component, pageProps}) {
    return (  
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          // Reset the state of your app here
          window.location.reload();
        }}
        onError={(error, errorInfo) => {
          // Always log errors to console for debugging
          console.error('Error:', error);
          console.error('Error Info:', errorInfo);
          
          // Handle array method errors more gracefully
          const arrayMethods = ['find', 'map', 'filter', 'reduce', 'forEach', 'some', 'every'];
          const methodMatch = arrayMethods.find?.(method => 
            error?.message?.includes(`${method} is not a function`)
          );
          
          if (methodMatch) {
            // Extract the variable name that caused the error
            const variableMatch = error?.message?.match(/(?:^|[^a-zA-Z0-9_$])([a-zA-Z0-9_$]+)\?\.${methodMatch}/);
            const variableName = variableMatch ? variableMatch[1] : 'unknown';
            
            // Just log the error for debugging but don't interrupt the flow
            console.warn('Array method error caught:', {
              message: error.message,
              method: methodMatch,
              variableName,
              component: errorInfo?.componentStack?.split('\n')[1]?.trim() || 'Unknown component',
              location: error.stack?.split('\n')[1]?.trim() || 'Unknown location',
              time: new Date().toISOString()
            });
            
            // Don't return anything - this lets the component continue with its natural error handling
            // The array operation will return undefined/empty array which components typically handle gracefully
          }
          
          // Let other errors propagate to the ErrorFallback component
        }}
      >
          <AuthContextProvider>      
            <QueryClientProvider client={queryClient}>      
                  <OfflineContext>
                    <ManagementContext>
                      <StateContext>
                          <Layout>
                              <Toaster/>
                              <Component {...pageProps}/>
                              <Analytics />
                          </Layout>
                      </StateContext>
                    </ManagementContext>
                  </OfflineContext>
              <ReactQueryDevtools initialIsOpen={false} position='bottom-right'/>      
            </QueryClientProvider>
          </AuthContextProvider>
      </ErrorBoundary>
    )
}

export default MyApp
